var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "popup__layer active" }, [
    _c("div", { staticClass: "popup__edit" }, [
      _c("div", { staticClass: "popup__edit--title" }, [
        _vm._v(" " + _vm._s(_vm.$t(`account.edit.changeAccountData`)) + " ")
      ]),
      _c("div", { staticClass: "popup__close", on: { click: _vm.close } }, [
        _c("span", { staticClass: "glicon-close-large" })
      ]),
      _c("form", [
        _c(
          "div",
          { staticClass: "form__group" },
          [
            _c("gl-input", {
              directives: [
                {
                  name: "skeletor",
                  rawName: "v-skeletor:onChange",
                  value: _vm.setValue,
                  expression: "setValue",
                  arg: "onChange"
                }
              ],
              attrs: {
                id: "company.displayName",
                type: "text",
                label: _vm.$t(`account.edit.companyName`),
                placeholder: _vm.$t(`account.edit.companyName`),
                value: _vm.companyData.displayName,
                errormessage: !_vm.$v.companyData.displayName.hasWhiteSpaces
                  ? _vm.$t("errors.invalidName")
                  : null
              },
              model: {
                value: _vm.companyData.displayName,
                callback: function($$v) {
                  _vm.$set(
                    _vm.companyData,
                    "displayName",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "companyData.displayName"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "form__group" },
          [
            _c("gl-input", {
              directives: [
                {
                  name: "skeletor",
                  rawName: "v-skeletor:onChange",
                  value: _vm.setValue,
                  expression: "setValue",
                  arg: "onChange"
                }
              ],
              attrs: {
                id: "company.cid",
                type: "text",
                label: _vm.$t("nouns.CID"),
                placeholder: _vm.$t("nouns.CID"),
                value: _vm.companyData.cid,
                errormessage: !_vm.$v.companyData.cid.hasWhiteSpaces
                  ? _vm.$t("errors.invalidCIF")
                  : null
              },
              model: {
                value: _vm.$v.companyData.cid.$model,
                callback: function($$v) {
                  _vm.$set(
                    _vm.$v.companyData.cid,
                    "$model",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "$v.companyData.cid.$model"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "popup__buttons" },
        [
          _c("gl-button", {
            attrs: {
              id: "company.btn-cancel",
              "color-secondary": "",
              type: "button",
              text: _vm.$t("actions.cancel")
            },
            on: {
              onClick: function($event) {
                $event.preventDefault()
                return _vm.close.apply(null, arguments)
              }
            }
          }),
          _c("gl-button", {
            attrs: {
              id: "company.btn-update",
              "color-primary": "",
              type: "button",
              text: _vm.$t("actions.update"),
              disabled: _vm.$v.$invalid || !_vm.dirtyFields
            },
            on: {
              onClick: function($event) {
                $event.preventDefault()
                return _vm.updateData.apply(null, arguments)
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }